module.exports = __webpack_public_path__ + "static/img/honor-swiper-2.eabfbf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/honor-swiper-2.png
// module id = Xtpb
// module chunks = 1